import React from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import styles from './ObservationCard.module.css';

export interface ObservationCardProps {
  children: React.ReactNode;
  bordered?: boolean;
  className?: string;
  visible?: boolean;
}

interface ObservationCardTextProps {
  children: React.ReactNode;
  className?: string;
}

interface ObservationCardHighlightProps {
  children: React.ReactNode;
}

const ObservationCardText: React.FC<ObservationCardTextProps> = ({
  children,
  className = '',
}) => (
  <p className={[styles.text, className].filter(Boolean).join(' ')}>{children}</p>
);

const ObservationCardHighlight: React.FC<ObservationCardHighlightProps> = ({ children }) => (
  <span className={styles.highlight}>{children}</span>
);

type ObservationCardComponent = React.FC<ObservationCardProps> & {
  Text: React.FC<ObservationCardTextProps>;
  Highlight: React.FC<ObservationCardHighlightProps>;
};

const ObservationCard: ObservationCardComponent = ({
  children,
  bordered = false,
  className = '',
  visible = true,
}) => {
  const reduceMotion = useReducedMotion();
  const cardClassName = [
    styles.card,
    bordered ? styles.bordered : '',
  ].filter(Boolean).join(' ');
  const transition = reduceMotion
    ? { duration: 0 }
    : { duration: 0.28, ease: [0.22, 1, 0.36, 1] as const };

  return (
    <div className={className || undefined}>
      <AnimatePresence initial={false}>
        {visible ? (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={transition}
          >
            <div className={cardClassName}>{children}</div>
          </motion.div>
        ) : null}
      </AnimatePresence>
    </div>
  );
};

ObservationCard.Text = ObservationCardText;
ObservationCard.Highlight = ObservationCardHighlight;

export default ObservationCard;
